import { render, staticRenderFns } from "./RollieTemplate.vue?vue&type=template&id=63a4830c"
import script from "./RollieTemplate.vue?vue&type=script&lang=ts"
export * from "./RollieTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports